import cn from 'classnames';
import Link from 'next/link';
// Hooks
import { useBreakpoints } from 'hooks';
// Components
import Text from 'ui3/Text/Text';
import LinkButton from 'ui3/LinkButton/LinkButton';
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
// Styles
import styles from './SectionHeader.module.scss';

type SectionHeaderProps = {
  title: string;
  onPrev?: () => void;
  onNext?: () => void;
  seeAllLink?: string;
  seeAllLinkTitle?: string;
  showArrows?: boolean;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
  className?: string;
};

const SectionHeader = ({
  title,
  onPrev,
  onNext,
  seeAllLink,
  seeAllLinkTitle,
  showArrows = false,
  prevDisabled = false,
  nextDisabled = false,
  className,
}: SectionHeaderProps) => {
  const { isBreakpointL } = useBreakpoints();
  const hasControls = showArrows || seeAllLink;

  return (
    <div className={cn(styles.header, className)}>
      <Text as="h2" variant="h5" color="lights-high">
        {title}
      </Text>
      {hasControls && (
        <div className={styles.headerControls}>
          {showArrows && (
            <>
              <button
                className={styles.arrowButton}
                onClick={onPrev}
                disabled={prevDisabled}
                aria-label="Previous"
              >
                <MillionsIcon name="arrowLeft" className={styles.arrowIcon} />
              </button>
              <button
                className={styles.arrowButton}
                onClick={onNext}
                disabled={nextDisabled}
                aria-label="Next"
              >
                <MillionsIcon name="arrowRight" className={styles.arrowIcon} />
              </button>
            </>
          )}
          {seeAllLink && (
            <>
              {!isBreakpointL ? (
                <Link href={seeAllLink} passHref>
                  <a className={styles.mobileTextWithArrow}>
                    <span className={styles.mobileText}>
                      {seeAllLinkTitle || 'See All'}
                    </span>
                    <MillionsIcon
                      name="arrowRight"
                      className={styles.mobileArrowIcon}
                    />
                  </a>
                </Link>
              ) : (
                <LinkButton
                  variant="secondary"
                  subVariant="outlined"
                  link={seeAllLink}
                  icon="chevronRight"
                  iconPosition="right"
                  size="medium"
                  iconSize={16}
                  className={styles.seeAllButton}
                >
                  {seeAllLinkTitle || 'See All'}
                </LinkButton>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default SectionHeader;
